module.exports = __webpack_public_path__ + "img/exchangeLimits2x.94f28b2c.png";